const FilterOn = () => (
  <>
    <path
      fill="currentColor"
      d="M11.058 17a.5.5 0 1 1 0-1h1.865a.5.5 0 0 1 0 1zm-3.75-4.5a.5.5 0 0 1 0-1h9.365a.5.5 0 0 1 0 1zM4.5 8a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1z"
    />
  </>
)
export default FilterOn
